import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { StyledRecharts } from '../../shared/recharts/Recharts.styled';
import { METHODOLOGYROLES } from '../Methodology.constants';

const MethodologyRoles: React.FC = () => {
  return (
    <div>
      <StyledRecharts className="methodology">
        <ResponsiveContainer height={330} width="99%" minWidth={400}>
          <BarChart data={METHODOLOGYROLES} layout="vertical">
            <XAxis
              type="number"
              allowDecimals={false}
              tickLine={false}
              padding={{ left: 10 }}
              tickFormatter={(tick) => {
                return `${tick}%`;
              }}
            />
            <YAxis
              type="category"
              dataKey="role"
              tickLine={false}
              width={160}
            />
            <Tooltip
              cursor={{ fill: 'transparent' }}
              labelStyle={{ display: 'none' }}
              separator=""
              formatter={(value: number) => [value.toFixed(1) + '%', '']}
              wrapperClassName="tooltip-x"
            />

            <Bar dataKey="share" barSize={8} radius={5} fill="#35B7B2"></Bar>
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default MethodologyRoles;
